import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '../redux/global-store'

// Hooks tipados para Redux
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector = <T>(selector: (state: RootState) => T) => useSelector<RootState, T>(selector)
